export class SubStateInfo
{
  Id: number
  SubStateCode: string
  SubStateName: string

  StateCode: string
  CycleCode: string

  FlagDelete: string
  CreateBy: string
  CreateByDisplay: string
  CreateDate: string
  UpdateBy: string
  UpdateByDisplay: string
  UpdateDate: string
}
